/* eslint-disable array-callback-return */
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import _ from "underscore";
import {
  ViedocButtonElement,
  ViedocCheckboxElement,
  ViedocDialogElement,
} from "../../../../secure/elements/ViedocReactElements";

import * as templateActions from "../../../../store/actions/templateActions";
import * as loaderActions from "../../../../store/actions/loaderActions";
import Loader from "../../shared/Loader/Loader";
import * as UtilsHelper from "../../../../../utils/utilsHelper";

const OtherSettings = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    settings,
    isStatusLoading,
    showToaster,
    isEtmfLocked,
    documentTemplateNames,
  } = useSelector((store) => store.template);
  const { isReadOnlyAdmin, isZoneLoading } = useSelector((store) => store.zone);

  const isAdminReadOnly = isReadOnlyAdmin || isEtmfLocked;
  const initialSettings = settings;

  const [setting, setSetting] = useState(initialSettings);

  const [invalidStatus, setInvalidStatus] = useState({
    displaytemplate: false,
    downloadtemplate: false,
    archivetemplate: false,
  });
  const [isSettingsChanged, setIsSettingsChanged] = useState(false);
  const [isShowError, setIsShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);

  const onHide = () => {
    setErrorMessage([]);
    setIsShowError(false);
  };

  const reviewProcess = [
    {
      checkValue: setting.islockdoconapproveenabled,
      handleCheckBox: "islockdoconapproveenabled",
      label: t("ADMIN.ADMINTAB_DOCUMENTLOCKTEXT"),
    },
    {
      checkValue: setting.isreasonforunlockdocenabled,
      handleCheckBox: "isreasonforunlockdocenabled",
      label: t("ADMIN.ADMINTAB_REASONFORUNLOCK"),
    },
  ];

  const documentTemplate = [
    {
      id: 1,
      label: t("ADMIN.TEXT_DISPLAYTEMPLATE"),
      value: "displaytemplate",
      value1: setting.displaytemplate,
      tooltip: t("ADMIN.TEXT_DISPLAYTEMPLATEDESC"),
      isInvalid: invalidStatus["displaytemplate"],
      errorMessage: errorMessage.filter((error) =>
        error.includes(t("ADMIN.TEXT_DISPLAYTEMPLATE"))
      ),
    },
    {
      id: 2,
      label: t("ADMIN.TEXT_DOWNLOADTEMPLATE"),
      value: "downloadtemplate",
      value1: setting.downloadtemplate,
      tooltip: t("ADMIN.TEXT_DOWNLOADTEMPLATEDESC"),
      isInvalid: invalidStatus["downloadtemplate"],
      errorMessage: errorMessage.filter((error) =>
        error.includes(t("ADMIN.TEXT_DOWNLOADTEMPLATE"))
      ),
    },
    {
      id: 3,
      label: t("ADMIN.TEXT_ARCHIVETEMPLATE"),
      value: "archivetemplate",
      value1: setting.archivetemplate,
      tooltip: t("ADMIN.TEXT_ARCHIVETEMPLATEDESC"),
      isInvalid: invalidStatus["archivetemplate"],
      errorMessage: errorMessage.filter((error) =>
        error.includes(t("ADMIN.TEXT_ARCHIVETEMPLATE"))
      ),
    },
  ];

  const dropZone = [
    {
      checkValue: setting.isshareddropzoneenabled,
      handleCheckBox: "isshareddropzoneenabled",
      label: t("ADMIN.ADMINTAB_ENABLESHAREDDROPZONE"),
    },
    {
      checkValue: setting.isprivatedropzoneenabled,
      handleCheckBox: "isprivatedropzoneenabled",
      label: t("ADMIN.ADMINTAB_ENABLEPRIVATEDROPZONE"),
    },
  ];

  useEffect(() => {
    dispatch(templateActions.getEnablingMilestoneStatus());
    dispatch(templateActions.getDocumentTemplateNames());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSetting(settings);
  }, [settings]);

  useEffect(() => {
    setIsSettingsChanged(
      JSON.stringify(initialSettings) === JSON.stringify(setting)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setting]);

  useEffect(() => {
    if (showToaster) {
      setTimeout(() => {
        dispatch(templateActions.clearSettingToasterMessage());
      }, 8000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showToaster]);

  const formActionDisable =
    isSettingsChanged &&
    !(
      initialSettings.displaytemplate !== setting.displaytemplate ||
      initialSettings.downloadtemplate !== setting.downloadtemplate ||
      initialSettings.archivetemplate !== setting.archivetemplate
    );
  const validateTemplates = (
    displayTemplate,
    downloadTemplate,
    archiveTemplate
  ) => {
    let invalidDisplayNames = "";
    let invalidDownloadNames = "";
    let invalidArchiveNames = "";
    let isdispNameValid;
    let isdownNameValid;
    let isarchiveNameValid;
    let downloadSplChars = "";
    let archiveSplChars = "";
    let recordNameTemplate = {};
    let splChars = ["/", ":", "*", "?", "<", ">", "|", "\\", '"', "."];
    if (displayTemplate && displayTemplate !== "") {
      invalidDisplayNames = UtilsHelper.getInvalidNames(
        displayTemplate,
        documentTemplateNames
      );
      isdispNameValid = UtilsHelper.checkCurlyBracesValue(
        displayTemplate,
        "displaytemplate",
        documentTemplateNames
      );
      invalidStatus["displaytemplate"] = !isdispNameValid;
    }
    if (downloadTemplate && downloadTemplate !== "") {
      invalidDownloadNames = UtilsHelper.getInvalidNames(
        downloadTemplate,
        documentTemplateNames
      );
      isdownNameValid = UtilsHelper.checkCurlyBracesValue(
        downloadTemplate,
        "downloadtemplate",
        documentTemplateNames
      );
      invalidStatus["downloadtemplate"] = !isdownNameValid;
    }
    if (archiveTemplate && archiveTemplate !== "") {
      invalidArchiveNames = UtilsHelper.getInvalidNames(
        archiveTemplate,
        documentTemplateNames
      );
      isarchiveNameValid = UtilsHelper.checkCurlyBracesValue(
        archiveTemplate,
        "archivetemplate",
        documentTemplateNames
      );
      invalidStatus["archivetemplate"] = !isarchiveNameValid;
    }
    downloadSplChars = filterSpecialChars(
      splChars,
      downloadTemplate,
      "downloadtemplate"
    );
    archiveSplChars = filterSpecialChars(
      splChars,
      archiveTemplate,
      "archivetemplate"
    );
    if (initialSettings.displaytemplate !== setting.displaytemplate) {
      recordNameTemplate = {
        ...recordNameTemplate,
        updateDisplayTemplate: true,
      };
    }
    if (initialSettings.downloadtemplate !== setting.downloadtemplate) {
      recordNameTemplate = {
        ...recordNameTemplate,
        updateDownloadTemplate: true,
      };
    }
    if (initialSettings.archivetemplate !== setting.archivetemplate) {
      recordNameTemplate = {
        ...recordNameTemplate,
        updateArchiveTemplate: true,
      };
    }
    handleTemplateUpdate(
      invalidDisplayNames,
      invalidDownloadNames,
      invalidArchiveNames,
      downloadSplChars,
      archiveSplChars,
      recordNameTemplate
    );
  };
  const filterSpecialChars = (splChars, template, name) => {
    let down = [];
    let archive = [];
    let downloadSplList = "";
    let archiveSplList = "";
    splChars.map((spl) => {
      if (template && template.includes(spl) === true) {
        if (name === "downloadtemplate") {
          down = [...down, spl];
        } else if (name === "archivetemplate") {
          archive = [...archive, spl];
        }
      }
    });
    if (!_.isEmpty(down)) {
      downloadSplList = down.map((item) => item).join("");
      return downloadSplList;
    } else if (!_.isEmpty(archive)) {
      archiveSplList = archive.map((item) => item).join("");
      return archiveSplList;
    } else {
      return downloadSplList;
    }
  };
  const handleTemplateUpdate = (
    invalidDisplayNames,
    invalidDownloadNames,
    invalidArchiveNames,
    downloadSplChars,
    archiveSplChars,
    recordNameTemplate
  ) => {
    let errorMsg = [];
    if (invalidDisplayNames && !_.isEmpty(invalidDisplayNames)) {
      errorMsg.push(t("ADMIN.TEXT_DISPLAYERROR") + invalidDisplayNames + ".\n");
    }
    if (invalidDownloadNames && !_.isEmpty(invalidDownloadNames)) {
      errorMsg.push(
        t("ADMIN.TEXT_DOWNLOADERROR") + invalidDownloadNames + ".\n"
      );
    }
    if (invalidArchiveNames && !_.isEmpty(invalidArchiveNames)) {
      errorMsg.push(t("ADMIN.TEXT_ARCHIVEERROR") + invalidArchiveNames + ".\n");
    }
    if (downloadSplChars && downloadSplChars !== "") {
      errorMsg.push(
        t("ADMIN.TEXT_DOWNLOADSPLCHARACTERS") + downloadSplChars + ".\n"
      );
    }
    if (archiveSplChars && archiveSplChars !== "") {
      errorMsg.push(
        t("ADMIN.TEXT_ARCHIVESPLCHARACTERS") + archiveSplChars + ".\n"
      );
    }

    if (
      _.isEmpty(invalidDisplayNames) &&
      _.isEmpty(invalidDownloadNames) &&
      _.isEmpty(invalidArchiveNames) &&
      downloadSplChars === "" &&
      archiveSplChars === ""
    ) {
      const updateSettingPayload = { ...setting, ...recordNameTemplate };
      dispatch(templateActions.updateMileStoneStatus(updateSettingPayload));
      setInvalidStatus({
        displaytemplate: false,
        downloadtemplate: false,
        archivetemplate: false,
      });
      setErrorMessage([]);
      setIsShowError(false);
      dispatch(loaderActions.hideError());
    } else if (!_.isEmpty(errorMsg)) {
      setErrorMessage(errorMsg);
      setInvalidStatus({
        ...invalidStatus,
        displaytemplate: !!errorMsg.find((error) =>
          error.includes(t("ADMIN.TEXT_DISPLAYTEMPLATE"))
        ),
        downloadtemplate: !!errorMsg.find((error) =>
          error.includes(t("ADMIN.TEXT_DOWNLOADTEMPLATE"))
        )
          ? true
          : false,
        archivetemplate: !!errorMsg.find((error) =>
          error.includes(t("ADMIN.TEXT_ARCHIVETEMPLATE"))
        )
          ? true
          : false,
      });
      dispatch(
        loaderActions.showError(
          t("ADMIN.TOAST_SETTINGSERROR"),
          "error",
          "warning"
        )
      );
    }
  };

  const handleReset = () => {
    setSetting(initialSettings);
  };

  const renderToaster = () => {
    if (showToaster) {
      return (
        <div className={!showToaster ? "setting-toaster-active" : ""}>
          <viedoc-toaster
            toasterHalfWidth
            suffix-icon="check"
            borderRadiusAllside
            showToaster
            class="setting-toaster"
            toasterMsg="Settings saved successfully"
          ></viedoc-toaster>
        </div>
      );
    }
    return null;
  };

  const handleCheckBox = (value, from) => {
    setSetting({
      ...setting,
      [from]: value,
    });
  };

  const renderFilterPanel = () => {
    return (
      <section className="filter-panel bb-1">
        <p className="f21 pb-15">{t("ADMIN.ADMINTAB_FILTERS")}</p>
        <div>
          <ViedocCheckboxElement
            checked={setting.ismilestoneenabled}
            display-mode="toggle"
            disabled={isAdminReadOnly}
            onChange={(e) => {
              handleCheckBox(e.srcElement.checked, "ismilestoneenabled");
            }}
          >
            {t("ADMIN.ADMINTAB_ENABLEMILESTONE")}
          </ViedocCheckboxElement>
        </div>
      </section>
    );
  };

  const renderReviewProcess = () => {
    return (
      <section className="filter-panel bb-1">
        <p className="f21 pb-15">{t("ADMIN.ADMINTAB_REVIEWPROCESS")}</p>
        {reviewProcess.map((fieldvalue) => (
          <div className="pb-15" key={fieldvalue.label}>
            <ViedocCheckboxElement
              display-mode="toggle"
              checked={fieldvalue.checkValue}
              disabled={isAdminReadOnly}
              onChange={(e) => {
                handleCheckBox(e.srcElement.checked, fieldvalue.handleCheckBox);
              }}
            >
              {fieldvalue.label}
            </ViedocCheckboxElement>
          </div>
        ))}
      </section>
    );
  };

  const renderDropZone = () => {
    return (
      <section className="filter-panel bb-1">
        <p className="f21 pb-15">{t("ADMIN.ADMINTAB_DROPZONE")}</p>
        {dropZone.map((fieldvalue) => (
          <div className="pb-15" key={fieldvalue.label}>
            <ViedocCheckboxElement
              checked={fieldvalue.checkValue}
              display-mode="toggle"
              disabled={isAdminReadOnly}
              onChange={(e) => {
                handleCheckBox(e.srcElement.checked, fieldvalue.handleCheckBox);
              }}
            >
              {fieldvalue.label}
            </ViedocCheckboxElement>
          </div>
        ))}
      </section>
    );
  };

  const renderSettingsErrorMessages = (fieldValue) => {
    return (
      fieldValue.isInvalid && (
        <div className="settings-error">
          {fieldValue.errorMessage.map((error, index) => (
            <div key={index} className="f14">
              <div className="settings-error-icon">
                <viedoc-icon name="warning" />
              </div>
              <div className="error-msg">{error}</div>
            </div>
          ))}
        </div>
      )
    );
  };

  const renderDocumentTemplate = () => {
    const handleTextChange = (e, fieldValue) => {
      const value = e.target.value;
      setSetting({
        ...setting,
        [fieldValue]: value,
      });
      setInvalidStatus({
        ...invalidStatus,
        [fieldValue]: false,
      });
    };
    return (
      <section className="filter-panel bb-1">
        <p className="f21 pb-15">{t("ADMIN.TEXT_DOCUMENTNAMETEMPLATES")}</p>

        {documentTemplate.map((fieldValue) => (
          <Fragment key={fieldValue.id}>
            <div
              className={`d-flex ${fieldValue.isInvalid ? "mb-5" : "mb-15"}`}
            >
              <div className="f16 mr-15 w-15">{`${fieldValue.label}:`}</div>

              <div className="d-flex srt-input-field">
                <div className="d-flex rt-input-field">
                  <div
                    className={`w-55 m-r-10 ${
                      fieldValue.isInvalid ? "required-warning" : ""
                    }`}
                  >
                    <viedoc-textfield>
                      <input
                        type="text"
                        placeholder={isAdminReadOnly ? "" : "Type..."}
                        disabled={isAdminReadOnly}
                        value={fieldValue.value1}
                        onChange={(e) => handleTextChange(e, fieldValue.value)}
                      />
                    </viedoc-textfield>
                  </div>
                  <div className="information">
                    <viedoc-tooltip>
                      <viedoc-icon name="info"></viedoc-icon>
                      <span slot="content">{fieldValue.tooltip}</span>
                    </viedoc-tooltip>
                  </div>
                </div>

                {renderSettingsErrorMessages(fieldValue)}
              </div>
            </div>
          </Fragment>
        ))}
      </section>
    );
  };

  const renderDocumentProperties = () => {
    return (
      <section className="filter-panel bb-1">
        <p className="f21 pb-15">{t("ADMIN.TEXT_DOCUMENTPROP")}</p>
        <div>
          <ViedocCheckboxElement
            checked={setting.istmflevelenabled}
            display-mode="toggle"
            disabled={isAdminReadOnly}
            onChange={(e) => {
              handleCheckBox(e.srcElement.checked, "istmflevelenabled");
            }}
          >
            {t("ADMIN.ADMINTAB_ENABLETMFLEVEL")}
          </ViedocCheckboxElement>
        </div>
      </section>
    );
  };

  const renderStructureNumber = () => {
    return (
      <section className="filter-panel bb-1">
        <p className="f21 pb-15">{t("ADMIN.ADMINTAB_STRUCTURE")}</p>
        <div>
          <ViedocCheckboxElement
            checked={setting.showstructurenumber}
            display-mode="toggle"
            disabled={isAdminReadOnly}
            onChange={(e) => {
              handleCheckBox(e.srcElement.checked, "showstructurenumber");
            }}
          >
            {t("ADMIN.ADMINTAB_STRUCTURECHECKBOX")}
          </ViedocCheckboxElement>
        </div>
      </section>
    );
  };

  const renderFormButtons = () => {
    return (
      <section className="pl-30 pr-30 footer-button">
        <div>
          <ViedocButtonElement
            class="mr-10"
            variant="neutral"
            size="small"
            type="button"
            onClick={() => handleReset()}
            disabled={formActionDisable}
            title={t("ADMIN.BUTTON_CANCEL")}
          >
            {t("ADMIN.BUTTON_CANCEL")}
          </ViedocButtonElement>
          <ViedocButtonElement
            variant={isSettingsChanged ? "neutral" : "success"}
            size="small"
            type="button"
            disabled={formActionDisable}
            onClick={() =>
              validateTemplates(
                setting.displaytemplate,
                setting.downloadtemplate,
                setting.archivetemplate
              )
            }
            title={t("ADMIN.BUTTON_SAVECHANGEBTN")}
          >
            {t("ADMIN.BUTTON_SAVECHANGEBTN")}
          </ViedocButtonElement>
        </div>
      </section>
    );
  };

  const renderErrorPopup = () => {
    return (
      <ViedocDialogElement
        open
        preventCloseByClick
        class="import-error"
        onHide={(e) => onHide(e)}
      >
        <section>
          <viedoc-icon name="warning"></viedoc-icon>

          {errorMessage.map((error, index) => (
            <Fragment key={index}>
              <p className="f16">{`${index + 1}. ${error}`}</p>
              <br />
            </Fragment>
          ))}
        </section>
      </ViedocDialogElement>
    );
  };

  return (
    <div className="Tmf-settings-main">
      {isStatusLoading || isZoneLoading ? (
        <Loader />
      ) : (
        <main className="other-setting-template">
          {isShowError && renderErrorPopup()}

          {showToaster && renderToaster()}

          <header className="header-padding bb-1">
            <h3>{t("ADMIN.ADMINTAB_SETTINGS")}</h3>
          </header>

          {renderFilterPanel()}

          {renderReviewProcess()}

          {renderDropZone()}

          {renderDocumentTemplate()}

          {renderDocumentProperties()}

          {renderStructureNumber()}

          {!isAdminReadOnly && renderFormButtons()}
        </main>
      )}
    </div>
  );
};

export default OtherSettings;
